/** Turn a DOI (bare or already a URL) into a clickable https://doi.org link. Lifted out of the
 *  article-details COI page for the Preprint productivity card (WO-2026-09-14 Track B). */
export const doiHref = (doi: string): string => (doi.startsWith("http") ? doi : `https://doi.org/${doi}`);
